import { DestroyRef, inject, Injectable, Signal, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FeatureFlagService } from './feature-flag.service';
import { EFeatureFlag } from './feature-flags-consts';

@Injectable({
  providedIn: 'root',
})
export class RebrandService {
  private readonly featureFlagService = inject(FeatureFlagService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly enabled = signal(false);

  readonly rebrandEnabled: Signal<boolean> = this.enabled.asReadonly();

  constructor() {
    this.publishOnceFlagsResolve();
  }

  private async publishOnceFlagsResolve(): Promise<void> {
    await this.featureFlagService.whenReady();

    this.publish();

    this.featureFlagService.flagsChange$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.publish());
  }

  private publish(): void {
    this.enabled.set(this.featureFlagService.getFlag(EFeatureFlag.REBRAND));
  }
}
